import { FormControl } from '@angular/forms';
import { StringHelper } from './string-helper';
import { TipoConsulta } from '../enum/tipoConsulta';
import { SessaoConsultaModel } from '../model/sessao-consulta.model';
import { TypeExportReportEnums } from './../enum/TypeExportReportEnums';
import * as moment from 'moment';
import { ValidationResult } from './validation-result';

export class UtilHelper {
  private static readonly nomeSessaoManterConsulta = 'consulta';

  public static ordenacao = (a: any, b: any) => {
    let retorno = 0;
    if (a.Descricao.toUpperCase() > b.Descricao.toUpperCase()) {
      retorno = 1;
    }
    if (a.Descricao.toUpperCase() < b.Descricao.toUpperCase()) {
      retorno = -1;
    }
    return retorno;
  }

  public static obterSessionStorageJson(_nomeSessao: string): any {
    return JSON.parse(sessionStorage.getItem(_nomeSessao));
  }

  public static RemoverManterConsulta(): any {
    sessionStorage.removeItem(this.nomeSessaoManterConsulta);
  }

  public static validarManterConsulta(_tipoConsulta: TipoConsulta): boolean {
    let valorRetorno = false;

    const sessaoConsulta = this.obterSessionStorageJson(this.nomeSessaoManterConsulta);
    if (sessaoConsulta !== null && sessaoConsulta.Tipo === _tipoConsulta) {
      valorRetorno = true;
    } else {
      this.RemoverManterConsulta();
    }

    return valorRetorno;
  }

  public static obterManterConsulta(): SessaoConsultaModel {
    return this.obterSessionStorageJson(this.nomeSessaoManterConsulta);

  }

  public static AtualizarManterConsulta(_tipoConsulta: TipoConsulta, _consulta: any): void {
    const sessaoConsulta = new SessaoConsultaModel();
    sessaoConsulta.Tipo = _tipoConsulta;
    sessaoConsulta.Consulta = _consulta;
    sessionStorage.setItem(this.nomeSessaoManterConsulta, JSON.stringify(sessaoConsulta));
  }

  public static downloadArquivo(_responseBlob: Blob, _tipoRelatorio: TypeExportReportEnums, _nomeBaseArquivo: string) {
    const link = document.createElement('a');
    link.setAttribute('type', 'hidden');
    const fileName = _nomeBaseArquivo + Date.now() + this.obterExtensaoArquivo(_tipoRelatorio);

    link.download = fileName;
    link.href = window.URL.createObjectURL(_responseBlob);
    document.body.appendChild(link);
    link.click();
  }

  private static obterExtensaoArquivo(_tipoRelatorio: TypeExportReportEnums): string {
    let valorRetorno: string;

    switch (_tipoRelatorio) {
      case TypeExportReportEnums.PDF:
        valorRetorno = '.pdf';
        break;
      case TypeExportReportEnums.EXCEL:
        valorRetorno = '.xls';
        break;
    }

    return valorRetorno;
  }

  public static objectWithoutProperties(modelObject: any, valueObject: any, keysIgnore?: Array<any>): any {
    const target: any = {};

    if (keysIgnore === undefined) {
      keysIgnore = [];
    }

    for (const i in valueObject) {
      if (keysIgnore.indexOf(i) < 0 && Object.prototype.hasOwnProperty.call(valueObject, i)) {
        target[i] = valueObject[i];
      }
    }
    return Object.assign(modelObject, target);
  }

  public static parseUndefinedToNull(value: any) {
    if (value === undefined) {
      return null;
    } else {
      return value;
    }
  }

  public static validNumber(event) {
    let valorRetorno = false;

    const teclasLiberadas = new Array('Numpad', 'Digit', 'Arrow', 'Delete', 'Enter', 'Backspace', 'Tab');
    const teclasLiberadasComCtrlkey = new Array('KeyA', 'KeyV', 'KeyX');

    teclasLiberadas.forEach(element => {
      if (event.code.toString().indexOf(element) === 0) {
        valorRetorno = true;
      }
    });

    if (!valorRetorno) {
      teclasLiberadasComCtrlkey.forEach(element => {
        if (event.code.toString() === element && event.ctrlKey) {
          valorRetorno = true;
        }
      });
    }

    return valorRetorno;
  }

  public static ParseDateFormat(valorData: Date, formatIn: string, formatOut: string): Date {
    return moment(moment(valorData, formatIn).format(formatOut)).toDate();
  }

  public static ParseStringToDate(valorData: string, formatIn: string): Date {
    return moment(valorData, formatIn).toDate();
  }

  public static IsDate(valorData: string, formatIn: string): boolean {
    return moment(valorData, formatIn).isValid();
  }

  public static ParseDateToNgbDate(data: any) {
    const date = new Date(data);
    let ngbDate: any;
    if (date !== null) {
      ngbDate = { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() };
    }
    return ngbDate;
  }

  public static ParseDateToString(valorData: Date, formatIn: string, formatOut: string): string {
    return moment(valorData, formatIn).format(formatOut);
  }

  public static ParseNgbDateToString(data: any): string {
    if (data) {
      const month = ('0' + data.month).slice(-2);
      const day = ('0' + data.day).slice(-2);
      const year = data.year;
      return `${year}-${month}-${day}`;
    } else {
      return null;
    }
  }

  public static obterJsonParametrosBase64(_entidadeBase64: string): any {
    if (StringHelper.isNullOrWhiteSpace(_entidadeBase64)) {
      return null;
    }

    const parametrosJson: string = atob(_entidadeBase64);
    return JSON.parse(parametrosJson);
  }

  public static gerarObjetEntity(_entidade: {}): [string, any][] {
    return this.getObjetEntries(_entidade);
  }

  public static getObjetEntries(obj) {
    let resArray;
    if (Object.entries === undefined) {
      resArray = this.criaEntries(obj);
      if (resArray === undefined) {
        resArray = this.criaEntries(obj);
      }
    } else {
      resArray = Object.entries(obj);
    }

    return resArray;
  };

  public static criaEntries(obj) {
    const ownProps = Object.keys(obj);
    let i = ownProps.length;
    const resArray = new Array(i); // preallocate the Array
    while (i > 0) {
      i--;
      resArray[i] = [ownProps[i], obj[ownProps[i]]];
    }
    return resArray;
  }

  public static gerarParametrosBase64ComObjetEntity(_entidade: {}): string {
    const entidadeObjeto = this.gerarObjetEntity(_entidade);
    return this.obterParametrosBase64(entidadeObjeto);
  }

  public static obterParametrosBase64(ids: Array<[string, any]>): string {
    let parametroBase64 = '';

    if (ids !== null && ids.length > 0) {
      let chaveValor = '';
      let addVirgula = false;
      for (const value of ids) {
        if (addVirgula) {
          chaveValor += `, \"${value[0].toString()}\"` + ':' + `\"${value[1].toString()}\"`;
        } else {
          chaveValor = `\"${value[0].toString()}\"` + ':' + `\"${value[1].toString()}\"`;
          addVirgula = true;
        }
      }

      chaveValor = `{${chaveValor}}`;
      parametroBase64 = btoa(chaveValor);
    }

    return parametroBase64;
  }
  public static getStringFromString(data: string): string {
    /******** RECEBE DATA NO FORMATO AAAA/MM/DD *******/
    if (data !== null && data !== undefined) {
      const year = data.substr(0, 4);
      const month = data.substring(5, 7);
      const day = data.substring(8, 10);
      return `${day}/${month}/${year}`;
    } else {
      return null;
    }
  }
  public static QtdNumeroComMascara(_numeroComMascara: string): number {
    let _numero;
    try {
      _numero = null;
      if (_numeroComMascara !== '') {
        _numero = _numeroComMascara.toString();
        while (_numero.indexOf('_') >= 0) {
          _numero = _numero.replace('_', '');
        }
      }
    } catch (e) {
      _numero = null;
    }

    return _numero;
  }

  public static isEmpty(myVar: any): boolean {
    return myVar === null || myVar === undefined || Object.keys(myVar.toString()).length === 0;
  }

  public static isNullOrWhiteSpace(str: FormControl): ValidationResult | undefined {
    if (!str.value || !str.value.trim()) {
      return { required: true };
    }
    return null;
  }
}




// WEBPACK FOOTER //
// ./src/app/shared/helpers/util-helper.ts